import { useEffect, useRef, useState } from "react";

const ThumbnailVideoPlayer = ({ videoPath, videoThumbnail }) => {
  const [showVideo, setShowVideo] = useState(false); // 내부 상태로 `showVideo` 관리
  const videoRef = useRef(null);

  // 비디오 재생/중지 토글 함수
  const toggleVideoPlay = () => {
    setShowVideo(!showVideo);
  };

  useEffect(() => {
    if ((showVideo && videoRef.current) || !videoThumbnail) {
      videoRef.current.play(); // showVideo가 true일 때 비디오 재생
    }
  }, [showVideo]); // showVideo 상태가 변경될 때마다 이 useEffect가 실행됩니다.

  return (
    <div className="video-container">
      {videoThumbnail && (
        <img
          src={videoThumbnail}
          alt="동영상 썸네일"
          onClick={toggleVideoPlay} // 클릭 시 비디오 플레이 상태 토글
          className="video-thumbnail"
          style={{ zIndex: showVideo ? 1 : 2 }}
        />
      )}

      <video
        ref={videoRef} // 비디오 요소에 ref 연결
        src={videoPath}
        autoPlay={showVideo}
        playsInline
        className="video-content"
        style={{ zIndex: showVideo ? 2 : 1 }}
      >
        <source src={videoPath} type="video/mp4" />
      </video>
    </div>
  );
};

export default ThumbnailVideoPlayer;
